import { useCallback } from 'react';
import { RefreshIcon } from '@setvi/shared/components/sicons';
import { useQueryClient } from '@tanstack/react-query';
import SButton, { SButtonProps } from '../sbutton';
import { TextColor } from '../../enums';

interface RefreshProps extends Partial<SButtonProps> {
  queries: string[];
}

const SRefreshButton = ({ queries, ...rest }: RefreshProps) => {
  const queryClient = useQueryClient();

  const handleRefresh = useCallback(() => {
    queries?.forEach(query => {
      queryClient.invalidateQueries({
        queryKey: [query]
      });
    });
  }, [queries, queryClient]);

  return (
    <SButton
      onClick={handleRefresh}
      startIcon={
        <RefreshIcon
          fill={rest.variant !== 'contained' ? TextColor.Blue : '#fff'}
        />
      }
      {...rest}>
      Refresh
    </SButton>
  );
};

export default SRefreshButton;
